import { render } from "./AssetsByDivision.vue?vue&type=template&id=38a71f9e"
import script from "./AssetsByDivision.vue?vue&type=script&lang=js"
export * from "./AssetsByDivision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__